import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ToolbarProps {
  searchPlaceholder: string;
  buttonLabel?: string;
  onCreateClick: () => void;
  onSearchChange?: (value: string) => void;
  searchValue?: string;
}

export const BaseToolbar: React.FC<ToolbarProps> = ({
  searchPlaceholder,
  buttonLabel,
  onCreateClick,
  onSearchChange,
  searchValue = "",
}) => (
  <section id="tools" className="mb-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-1 items-center space-x-4">
        <div className="relative flex-1 max-w-xl">
          <Input
            type="search"
            placeholder={searchPlaceholder}
            className="pl-10"
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
          <i className="fa-solid fa-search absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400"></i>
        </div>
        <button className="flex items-center space-x-2 rounded-lg border border-neutral-300 px-4 py-2">
          <i className="fa-solid fa-filter text-neutral-600"></i>
          <span>Filters</span>
        </button>
      </div>
      {buttonLabel && (
        <Button onClick={onCreateClick} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          {buttonLabel}
        </Button>
      )}
    </div>
  </section>
);
